// Capture entries synchronously during drop: the browser clears DataTransfer later.
export async function collectDroppedFiles(dataTransfer) {
  const items = Array.from(dataTransfer.items || []).filter((item) => item.kind === 'file');
  const roots = items.map((item) => {
    const getEntry = item.getAsEntry || item.webkitGetAsEntry;
    return { entry: getEntry ? getEntry.call(item) : null, file: item.getAsFile() };
  });
  const fallback = Array.from(dataTransfer.files || []);
  const files = [];
  let visited = 0;
  const walk = async (entry, parent = '') => {
    visited += 1;
    if (visited > 10000)
      throw new Error('This folder has more than 10,000 items. Select a smaller folder.');
    const relativePath = parent ? `${parent}/${entry.name}` : entry.name;
    if (entry.isFile) {
      const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
      files.push({ file, relativePath });
    } else if (entry.isDirectory) {
      const reader = entry.createReader();
      // Chromium returns directory entries in batches (often 100 at a time).
      let entries;
      do {
        entries = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
        for (const child of entries) await walk(child, relativePath);
      } while (entries.length > 0);
    } else throw new Error(`Unable to read ${relativePath}. Use Import folder instead.`);
  };
  if (!roots.length)
    return fallback.map((file) => ({ file, relativePath: file.webkitRelativePath || file.name }));
  for (const root of roots) {
    if (root.entry) await walk(root.entry);
    else if (root.file)
      files.push({ file: root.file, relativePath: root.file.webkitRelativePath || root.file.name });
    else throw new Error('Folder dropping is unavailable. Use Import folder instead.');
  }
  return files;
}
